import React, { Component } from 'react'

import ContentEditable from 'react-contenteditable'
import ControlsLikeContainer from 'components/controls-like-container/controls-like-container'

import {
    isMobile,
    ucfirst
} from 'utils'

export default class MessageGroupMessage extends Component {
    componentDidMount() {
        const {
            handleMessageItemMountOrLoad,
            message
        } = this.props

        const userId = message && message.sender_id ? message.sender_id : null

        handleMessageItemMountOrLoad(userId)
    }

    isEditing = _ => {
        const {
            message,
            currentlyEditedComment,
        } = this.props

        return currentlyEditedComment && currentlyEditedComment.id === message.id
    }

    getMessageText = _ => {
        const {
            type,
            message,
            currentlyEditedComment,
            allUsers
        } = this.props

        let messageText = null

        if (type !== 'comment') {
            return message.message_text
        }

        // All the below is just for comments.
        if (this.isEditing()) {
            messageText = currentlyEditedComment.text
        } else {
            messageText = message.text
        }

        messageText = messageText.replace(/<a(\s[^>]*)?>.*?<\/a>/ig, a => {
            if (!a.includes('#mention')) {
                return a
            }

            const rawMentionIds = a.match(/href="#mention-([^"]*")/g)

            if (rawMentionIds) {
                const mentionId = rawMentionIds[0].replace('href="#mention-', '').replace('"', '')

                const user = allUsers[mentionId]

                return user ? `<strong>${user.first_name} ${user.last_name}</strong>` : null
            } else {
                return null
            }
        })

        return messageText
    }

    renderReactions = _ => {
        const {
            message,
            isMine,
            isArchived,
            allUsers,
            thisUser,
            reactEntity
        } = this.props

        const reactionGroups = message.reactionGroups || []

        if (!reactionGroups.length) {
            return null
        }

        // Same rule as likes: you can't react to your own messages.
        const canReact = !isMine && !isArchived

        return (
            <div className="message-reactions" onClick={e => e.stopPropagation()}>
                {reactionGroups.map(({ emoji, userIds }) => {
                    const names = userIds
                        .map(userId => allUsers[userId])
                        .filter(user => user)
                        .map(user => user.first_name)

                    let className = 'message-reaction tooltip-trigger'

                    if (userIds.indexOf(thisUser.id) !== -1) {
                        className += ' mine'
                    }

                    if (canReact) {
                        className += ' clickable'
                    }

                    return (
                        <span
                            key={emoji}
                            className={className}
                            onClick={canReact ? (_ => reactEntity(message, emoji)) : undefined}
                        >
                            {emoji} <span className="message-reaction-count">{userIds.length}</span>
                            {names.length ?
                                <div className="tooltip">
                                    {names.join(', ')}
                                </div>
                                : null}
                        </span>
                    )
                })}
            </div>
        )
    }

    render() {
        const {
            message,
            isMine,
            index,
            type,
            allUsers,
            formatText,
            likeEntity,
            editComment,
            deleteComment,
            replyEntity,
            saveEditedComment,
            cancelEditComment,
            thisUser,
            isArchived,
            contentRefs,
            isGroup,
            getUserName,
            user,
            handleEditCommentChange,
            isActiveSearchResult,
            isReply,
            reactEntity
        } = this.props

        const isEditing = this.isEditing()

        const showUserNameOnMobile = isMobile() && !isMine && index === 0 && type === 'message'

        let messageText = this.getMessageText()

        let messageClassName = 'message-content controls-container-container' // I know, but it IS a container of a container.

        if (isEditing) {
            messageClassName += ' edited'
        }

        if (isActiveSearchResult) {
            messageClassName += ' active-search-result'
        }

        // linkify isn't bringing the goods, so we'll do our own target _blank here.
        const formattedMessageText = (() => {
            if (isActiveSearchResult) {
                const variations = [
                    isActiveSearchResult,
                    isActiveSearchResult.toUpperCase(),
                    isActiveSearchResult.toLowerCase(),
                    ucfirst(isActiveSearchResult),
                ]

                variations.forEach(variation => {
                    messageText = messageText.replace(variation, `<span class="active-search-result-word">${variation}</span>`)
                })
            }

            if (isEditing) {
                return messageText
            }

            return formatText(messageText)
        })()

        return (
            <div
                key={index}
                className={messageClassName}
                id={'message-group-' + message.id}
                ref={ref => {
                    if (isActiveSearchResult) {
                        window.activeMessage = ref
                    }
                }}
            >
                {
                    (showUserNameOnMobile && isGroup) &&
                    getUserName(user)
                }
                {isReply ?
                    <span className='replying-to-name'>
                        {getUserName(message.user)}
                    </span>
                    : null}
                <div>
                    <ContentEditable
                        className="needsclick"
                        ref={ref => { contentRefs[message.id] = ref }}
                        onChange={handleEditCommentChange}
                        html={formattedMessageText}
                        disabled={!isEditing}
                    />
                    {(() => {
                        if (isReply) {
                            return null
                        }

                        // Comments and other people's messages get the full hover
                        // toolbar (like / reply / edit / delete), same as before.
                        const canUseControls = type === 'comment' || !isMine

                        // Your own chat messages don't get that toolbar, but you
                        // should still see who liked them.
                        const hasLikers = message.likersIds && message.likersIds.length

                        if (!canUseControls && !hasLikers) {
                            return null
                        }

                        return (
                            <ControlsLikeContainer
                                likeCallback={canUseControls ? (_ => {
                                    if (!isArchived) {
                                        likeEntity(message, type)
                                    }
                                }) : null}
                                likersIds={message.likersIds}
                                likersAsTooltip={type === 'message'}
                                reactCallback={(canUseControls && type === 'message') ? (emoji => reactEntity(message, emoji)) : null}
                                allUsers={allUsers}
                                thisUser={thisUser}
                                isEditing={isEditing}
                                isArchived={isArchived}
                                canEdit={canUseControls && (isMine && message.id)}
                                canReply={canUseControls}
                                editCallback={_ => editComment(message)}
                                deleteCallback={_ => deleteComment(message)}
                                saveCallback={saveEditedComment}
                                cancelCallback={cancelEditComment}
                                replyCallback={_ => replyEntity(message)}
                            />
                        )
                    })()}
                    {(!isReply && type === 'message') ? this.renderReactions() : null}
                </div>
            </div>
        );
    }
}
